import React from 'react';
import {Modal, Button, Icon} from '@/ui-kits';

interface DuplicateFilesModalProps {
  open: boolean;
  onClose: () => void;
  duplicateFileNames: string[];
}

export const DuplicateFilesModal: React.FC<DuplicateFilesModalProps> = ({
  open,
  onClose,
  duplicateFileNames,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="p-0 w-[90%] sm:w-auto max-w-[500px] rounded-2xl">
      <div className="bg-white rounded-xl p-4 sm:p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 sm:top-4 sm:right-4 p-1 rounded-full">
          <Icon type="close" className="size-4 sm:size-5" />
        </button>

        <div className="flex flex-col items-center text-center mt-2 px-2 sm:px-4">
          <p className="text-ui_blue text-base sm:text-lg font-FigtreeSemiBold leading-relaxed mb-4">
            Some files are duplicates. Please review the list below and remove them before clicking Next.
          </p>

          <div className="w-full mb-4">
            <div className="flex flex-wrap gap-1 justify-center items-center">
              {duplicateFileNames.map((fileName, index) => (
                <React.Fragment key={index}>
                  <span className="text-rejection text-sm sm:text-base font-FigtreeMedium">
                    '{fileName}'
                  </span>
                  {index < duplicateFileNames.length - 1 && (
                    <span className="text-rejection text-sm sm:text-base font-FigtreeMedium">,</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

        </div>
      </div>
    </Modal>
  );
};

